module.exports = __webpack_public_path__ + "static/media/post.c353d95a.png";